import {
  getGuestSessionData,
  getUserSessionData
} from '@/Application/Hooks/GetCustomerData';
import { useAppSelector } from '@/Application/Hooks/Redux';

export const useGetTokenUserId = () => {
  const orderToken = useAppSelector(
    (state) => state?.billing.paymentSuccess?.tokenUserId
  );
  const stateToken = useAppSelector((state) => state?.tokenUserId?.tokenUserId);

  const sessionData = getUserSessionData();
  const guestSessionData = getGuestSessionData();

  const localStorageToken =
    sessionData?.tokenUserId || guestSessionData?.tokenUserId;

  return orderToken || stateToken || localStorageToken || '';
};

export default useGetTokenUserId;
